(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define('shared-g2m-logic',["lodash", "moment"], factory);
	else if(typeof exports === 'object')
		exports["sharedG2mLogic"] = factory(require("lodash"), require("moment"));
	else
		root["sharedG2mLogic"] = factory(root["lodash"], root["moment"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Products = __webpack_require__(1);
	
	Object.defineProperty(exports, 'Products', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Products).default;
	  }
	});
	
	var _mixpanel = __webpack_require__(4);
	
	Object.defineProperty(exports, 'mixpanel', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_mixpanel).default;
	  }
	});
	
	var _componentCommunicator = __webpack_require__(6);
	
	Object.defineProperty(exports, 'componentCommunicator', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_componentCommunicator).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	  function _class(products) {
	    _classCallCheck(this, _class);
	
	    this.products = products != null ? products : [];
	
	    if (this.products.constructor !== Array) {
	      throw new Error('Invalid data type. Provide an array.');
	    }
	  }
	
	  _createClass(_class, [{
	    key: 'toObject',
	    value: function toObject() {
	      return this.products;
	    }
	  }, {
	    key: 'setObject',
	    value: function setObject(products) {
	      this.products = products;
	    }
	  }, {
	    key: 'findExpiringTrial',
	    value: function findExpiringTrial(activeDate) {
	      return (0, _lodash.find)(this.products, function (product) {
	        var check = product.product === 'GoToMeeting' && product.active && product.trial && !product.autoRenew;
	
	        if (activeDate) {
	          check = check && (0, _moment2.default)(product.endDate).diff(activeDate) < 0;
	        }
	
	        return check;
	      });
	    }
	  }, {
	    key: 'isBillingAdmin',
	    value: function isBillingAdmin(userKey) {
	      if (!userKey) {
	        throw new Error('No user key specified');
	      }
	
	      return this.products.filter(function (product) {
	        return product.product === 'GoToMeeting';
	      }).some(function (product) {
	        return product.billingAdminUserKey === userKey;
	      });
	    }
	  }, {
	    key: 'findActiveG2m',
	    value: function findActiveG2m() {
	      return (0, _lodash.find)(this.products, function (product) {
	        return product.active && product.product === 'GoToMeeting' || product.product === 'GoToMeetingFree';
	      });
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;
	;

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _setSuperProperties = __webpack_require__(5);
	
	var _setSuperProperties2 = _interopRequireDefault(_setSuperProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { setSuperProperties: _setSuperProperties2.default };

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Products = __webpack_require__(1);
	
	var _Products2 = _interopRequireDefault(_Products);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getProductProperties = function getProductProperties(productsList, key) {
	  var products = new _Products2.default(productsList);
	
	  var billingAdmin = void 0;
	  var plan = void 0;
	  var daysSinceTrialStart = void 0;
	
	  var expiringTrial = products.findExpiringTrial();
	  var activeProduct = products.findActiveG2m();
	
	  if (!activeProduct) {
	    plan = 'Offline';
	  } else {
	    plan = 'Online';
	
	    billingAdmin = products.isBillingAdmin(key);
	
	    if (expiringTrial) {
	      var trialDaysLeft = (0, _moment2.default)(expiringTrial.endDate).diff((0, _moment2.default)(), 'days');
	      var trialDay = expiringTrial.billingDuration - trialDaysLeft + 1;
	      daysSinceTrialStart = trialDay;
	    }
	  }
	
	  return _extends({}, activeProduct, {
	    'Billing Admin': billingAdmin,
	    'Plan': plan,
	    'Days Since Trial Start': daysSinceTrialStart
	  });
	};
	
	var getG2mmProperties = function getG2mmProperties() {
	  var g2mmStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN';
	
	  var status = {
	    'UNKNOWN': 'Unknown',
	    'RESERVED': 'Yes',
	    'UNRESERVED': 'No'
	  };
	
	  return { 'GoToMeetMe Active': status[g2mmStatus] };
	};
	
	var getCoorganizers = function getCoorganizers(coorganizers) {
	  if (coorganizers) {
	    return { 'Co-Organizer Count': coorganizers.total };
	  }
	};
	
	exports.default = function (mixpanel, data) {
	  if (data.userMe) {
	    mixpanel.identify(data.userMe.key);
	    mixpanel.register({ 'User Key': data.userMe.key });
	    mixpanel.register({ 'Account Key': data.userMe.accountKey });
	
	    mixpanel.register(getProductProperties(data.products, data.userMe.key));
	    mixpanel.register(getG2mmProperties(data.g2mmStatus));
	    mixpanel.register(getCoorganizers(data.coorganizers));
	  }
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalWindow = __webpack_require__(7);
	
	var _globalWindow2 = _interopRequireDefault(_globalWindow);
	
	var _postMessage = __webpack_require__(8);
	
	var _postMessage2 = _interopRequireDefault(_postMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This module handles communication with external applications
	 * that consume this application.
	 */
	var activeStrategy = void 0;
	var strategyOptions = void 0;
	
	// Directory of communication strategies
	var strategies = {
	  'global-window': _globalWindow2.default,
	  'post-message': _postMessage2.default
	};
	
	exports.default = {
	
	  /**
	   * Set the strategy. Also serves as an initialization function, which must be called before communicating
	   * @param {string} strategy - The strategy name
	   */
	  setStrategy: function setStrategy(strategy, options) {
	    activeStrategy = strategies[strategy];
	
	    if (!activeStrategy) {
	      throw new Error('Strategy not found');
	    }
	
	    strategyOptions = options;
	  },
	
	  communicate: function communicate(message, data) {
	    if (!activeStrategy) {
	      throw new Error('Strategy must be set before communicating');
	    }
	
	    activeStrategy(message, data, strategyOptions);
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (message, data, options) {
	  var messages = window[options.namespace];
	
	  if (messages && messages[message]) {
	    messages[message](data);
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (message, data, options) {
	
	  // IE <= 9 cannot consume a message unless it is a string
	  window.parent.postMessage(JSON.stringify({
	    id: options.id,
	    message: message,
	    data: data
	  }), '*');
	};

/***/ }
/******/ ])
});
;
//# sourceMappingURL=shared-g2m-logic.js.map;
